// İSG uzmanı portalı — iOS/Android mağaza indirme bağlantıları (api-contract §26). Salt
// sunum: container `useAppSettings` ile linkleri çeker, buraya `ios`/`android` (biri/ikisi
// `null` olabilir) geçer. İki yüzey paylaşır — Mobil Uygulama sayfası (`MobileAppPage`) ve
// anasayfa app-info kartı (`DashboardPage`) — bu yüzden tek bileşen (kopya yok). İkisi de
// boşsa "yakında" bilgisi; dolu olan(lar) için mağaza butonu.
//
// Dış bağlantılar yeni sekmede açılır (`rel="noopener noreferrer"` — güvenlik). Buton içeriği
// `asChild` ile `<a>`'e devredilir (Button primitifi Radix Slot). web-supplier
// `AppDownloadLinks` ile AYNI desendir.

import { Button } from '@isgportal/shared';
import { Apple, Play } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface AppDownloadLinksProps {
  iosAppUrl: string | null;
  androidAppUrl: string | null;
  /** Buton boyutu (sayfada `lg`, kart içinde `md`). Varsayılan `md`. */
  size?: 'md' | 'lg';
}

/**
 * Mağaza butonları veya "yakında" bilgisi. İkisi de `null` → uygulama henüz mağazada değil
 * (bilgi bloğu); en az biri dolu → o platform(lar) için mağaza butonu.
 */
export function AppDownloadLinks({ iosAppUrl, androidAppUrl, size = 'md' }: AppDownloadLinksProps) {
  const { t } = useTranslation();

  if (!iosAppUrl && !androidAppUrl) {
    return (
      <div className="rounded-md bg-surface-muted px-4 py-3 text-sm text-muted">
        {t('appDownload.comingSoon.body')}
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3 sm:flex-row">
      {iosAppUrl ? (
        <Button asChild variant="secondary" size={size} className="justify-start sm:justify-center">
          <a href={iosAppUrl} target="_blank" rel="noopener noreferrer">
            <Apple className="h-5 w-5" aria-hidden="true" />
            {t('appDownload.ios')}
          </a>
        </Button>
      ) : null}
      {androidAppUrl ? (
        <Button asChild variant="secondary" size={size} className="justify-start sm:justify-center">
          <a href={androidAppUrl} target="_blank" rel="noopener noreferrer">
            <Play className="h-5 w-5" aria-hidden="true" />
            {t('appDownload.android')}
          </a>
        </Button>
      ) : null}
    </div>
  );
}
